import React from 'react';
import { Switch, useRouteMatch } from 'react-router-dom';

import { RouteGuard } from 'src/routing/RouteGuard';

import { PathwayCreateIntroPage } from './pages/PathwayCreateIntroPage';
import { PathwayCreateQuestionnairePage } from './pages/PathwayCreateQuestionnairePage';
import { PathwayCreateSummaryPage } from './pages/PathwayCreateSummaryPage';
import { PathwayPage } from './pages/PathwayPage/PathwayPage';
import { PathwayAssessmentPage } from './pages/PathwayAssessmentPage';
import { PathwayProviderModalRouteToolkit } from './pages/PathwayProviderModalPage';
import { PathwaySessionDetailModalRouteToolkit } from './pages/PathwaySessionDetailModalPage';
import { PathwaySessionCompletePage } from './pages/PathwaySessionCompletePage';
import { PathwayReviewPage } from './pages/PathwayReviewPage';
import { PathwaysAboutPage } from './pages/PathwaysAboutPage';
import { PathwaysPage } from './pages/PathwaysPage';

export const PathwaysRouter = () => {
    const { path } = useRouteMatch();

    return (
        <>
            <PathwayProviderModalRouteToolkit.ModalRoute
                basePath={`${path}/:uuid`}
                analytics={{ pageName: 'pathway-provider-modal' }}
            />
            <PathwaySessionDetailModalRouteToolkit.ModalRoute
                basePath={`${path}/:uuid`}
                analytics={{ pageName: 'pathway-session-detail-modal' }}
            />
            <Switch>
                <RouteGuard
                    path={path}
                    analytics={{ pageName: 'pathways' }}
                    component={PathwaysPage}
                    exact
                    secured
                />
                <RouteGuard
                    path={`${path}/about`}
                    analytics={{ pageName: 'pathways-about' }}
                    component={PathwaysAboutPage}
                    exact
                    secured
                />
                <RouteGuard
                    path={`${path}/:uuid/assessment`}
                    analytics={{ pageName: 'pathway-assessment' }}
                    component={PathwayAssessmentPage}
                    exact
                    secured
                />
                <RouteGuard
                    path={`${path}/:uuid/create/questionnaire/:questionnaireType?`}
                    analytics={{ pageName: 'pathway-create-questionnaire' }}
                    component={PathwayCreateQuestionnairePage}
                    noLayout
                    secured
                />
                <RouteGuard
                    path={`${path}/:uuid/create/summary`}
                    analytics={{ pageName: 'pathway-create-summary' }}
                    component={PathwayCreateSummaryPage}
                    noLayout
                    secured
                />
                <RouteGuard
                    path={`${path}/:uuid/create`}
                    analytics={{ pageName: 'pathway-create-intro' }}
                    component={PathwayCreateIntroPage}
                    noLayout
                    secured
                />
                <RouteGuard
                    path={`${path}/:uuid/session-complete`}
                    analytics={{ pageName: 'pathway-session-complete' }}
                    component={PathwaySessionCompletePage}
                    noLayout
                    secured
                />
                <RouteGuard
                    path={`${path}/:uuid/review`}
                    analytics={{ pageName: 'pathway-review' }}
                    component={PathwayReviewPage}
                    noLayout
                    secured
                />
                <RouteGuard
                    path={`${path}/:uuid`}
                    analytics={{ pageName: 'pathway-detail' }}
                    component={PathwayPage}
                    secured
                />
            </Switch>
        </>
    );
};
